import { useBrand } from '../context/BrandContext';
import FastestFormCRMPipelines from './fastestform/CRMPipelines';
import AbleCRMPipelines from './able/CRMPipelines';

export default function CRMPipelines() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleCRMPipelines /> : <FastestFormCRMPipelines />;
}
